import { useTranslate } from '@tolgee/react';
import { formatRelativeTime } from 'utils/timeFormat';

interface FootprintTimelineItemProps {
  title: string;
  timestamp?: string;
  isLast?: boolean;
  pageUrl: string;
}

export const FootprintTimelineItem = (props: FootprintTimelineItemProps) => {
  const { title, timestamp, isLast, pageUrl } = props;
  const { t } = useTranslate();

  return (
    <div className="flex gap-3 px-4 items-start text-[#515359] min-h-[44px]">
      <div className="w-10 text-right text-[12px]  flex-shrink-0 pt-0.5 text-nowrap">
        {timestamp ? formatRelativeTime(timestamp, t) : '-'}
      </div>

      <div className="flex flex-col pt-2 items-center self-stretch">
        <div className="w-[6px] h-[6px] rounded-full bg-[#D3D7E0]" />
        {!isLast ? <div className="w-px flex-1 bg-[#D3D7E0] mt-[5px]" /> : null}
      </div>

      <a
        className="flex-1 text-[12px] text-[#515359] truncate pt-0.5"
        href={pageUrl}
        title={title}
        target="_blank"
        rel="noreferrer"
      >
        {title}
      </a>
    </div>
  );
};
